// docs/real-estate/be/10-api-reference.md §A13.
import { request } from './http';

export function listAppointments(query) {
  return request({ path: '/properties/appointments', params: query });
}

export function getAppointment(id) {
  return request({ path: `/properties/appointments/${id}` });
}

// fields: { appointment_type, property_id, unit_id?, customer_id,
// conversation_id?, date, start_time, duration_minutes? (handover only),
// agent_id? | auto_assign_agent?, status?, location_type?, customer_notes?,
// agent_notes?, handover_checklist? }
export function createAppointment(fields) {
  return request({
    method: 'post',
    path: '/properties/appointments',
    data: fields,
  });
}

// Editable fields only: agent_id (agent rows only), customer_notes,
// agent_notes, handover_checklist, location_type, location_note. Date/time
// change only through reschedule().
export function patchAppointment(id, fields) {
  return request({
    method: 'patch',
    path: `/properties/appointments/${id}`,
    data: fields,
  });
}

export function setAppointmentStatus(id, status, reason) {
  return request({
    method: 'put',
    path: `/properties/appointments/${id}/status`,
    data: reason ? { status, reason } : { status },
  });
}

// fields: { date, start_time, duration_minutes? (handover only), agent_id?
// | auto_assign_agent? (agent mode only), reason? }
export function rescheduleAppointment(id, fields) {
  return request({
    method: 'put',
    path: `/properties/appointments/${id}/reschedule`,
    data: fields,
  });
}

export function deleteAppointment(id) {
  return request({ method: 'delete', path: `/properties/appointments/${id}` });
}
